"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDrainPipeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.drain-pipe_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "drain-pipe_outline_svg__transparent_box" },
            React.createElement("path", { className: "drain-pipe_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "drain-pipe_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "drain-pipe_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M23.33 29a6.2 6.2 0 01-3.66-1.25A6.09 6.09 0 0116 29a6.17 6.17 0 01-3.66-1.25A6.09 6.09 0 018.67 29a6.3 6.3 0 01-4.42-1.91l-.66-.75L5.08 25l.66.75A4.35 4.35 0 008.67 27a4.1 4.1 0 002.91-1.23l.75-.84.75.83A4.31 4.31 0 0016 27a4.16 4.16 0 002.92-1.23l.74-.84.75.83A4.31 4.31 0 0023.33 27a4.14 4.14 0 002.92-1.23l.66-.75 1.5 1.31-.65.75A6.19 6.19 0 0123.33 29zM28 3H16c-3.15 0-5.74 3.06-6 6.93a14.84 14.84 0 012.12-.84C12.59 6.74 14.15 5 16 5c2.21 0 4 2.47 4 5.5S18.21 16 16 16c-2.82 0-5 3.23-5 6h2c0-1.75 1.45-4 3-4h12v-2h-7.93A8.46 8.46 0 0022 10.5 8.46 8.46 0 0020.07 5H28z" }),
            React.createElement("path", { d: "M16 13v-2c-5.54 0-10.91 4.68-12 10.44l-.08.56H6v-.2C6.88 17 11.38 13 16 13z" }))));
}
exports.default = SvgDrainPipeOutline;
//# sourceMappingURL=DrainPipeOutline.js.map